module.exports = __webpack_public_path__ + "static/media/ND-1.5-MX5.e7c9d6d7.webp";